import CrudBase from '../../../CrudBase';

const origens = new CrudBase('api/comercial/pedidos/origens');

export default origens.defaultMethods;
